const Tickets = () => {
  return <div className="dashboard-wrapper">Tickets page</div>;
};

export default Tickets;
